import {
  useEffect,
  useState
} from "react";

import {
  Link,
  useNavigate
} from "react-router-dom";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function Purchases() {

  const navigate =
    useNavigate();

  const [purchases,
    setPurchases] =
    useState([]);

  const [page,
    setPage] =
    useState(1);

  const [pages,
    setPages] =
    useState(1);

  const [search,
    setSearch] =
    useState("");

  useEffect(() => {
    loadPurchases();
  }, [page, search]);

  const loadPurchases =
    async () => {

      try {

        const res =
          await API.get(
            `/purchases?page=${page}&search=${search}`
          );

        setPurchases(
          res.data.purchases || []
        );

        setPages(
          res.data.pages || 1
        );

      } catch (err) {
        console.log(err);
      }

    };

  const deletePurchase =
    async (id) => {

      if (
        !window.confirm(
          "Delete Purchase?"
        )
      ) return;

      try {

        await API.delete(
          `/purchases/${id}`
        );

        loadPurchases();

      } catch (err) {
        console.log(err);
      }

    };

  return (<div>

    <div
      className="
    flex
    flex-col
    md:flex-row
    justify-between
    items-center
    gap-4
    mb-6
  "
    >

      <h1
        className="
      text-3xl
      font-bold
    "
      >
        Purchases
      </h1>

      {hasPermission("purchase.add") && (
        <Link
          to="/admin/purchases/add"
          className="
      bg-yellow-500
      text-black
      px-5
      py-3
      rounded-xl
      font-semibold
    "
        >
          Add Purchase
        </Link>
      )}

    </div>

    <input
      value={search}
      onChange={(e) =>
        setSearch(
          e.target.value
        )
      }
      placeholder="Search Invoice..."
      className="
    w-full
    md:w-96
    p-3
    rounded-xl
    bg-[#111]
    border
    border-yellow-500/20
    mb-6
  "
    />

    {/* MOBILE */}

    <div className="md:hidden space-y-4">

      {purchases.map(
        (item) => (

          <div
            key={item.id}
            className="
          bg-[#111]
          p-4
          rounded-2xl
          border
          border-yellow-500/10
        "
          >

            <div className="flex justify-between">
              <span>Invoice</span>
              <span>
                {item.invoice_no}
              </span>
            </div>

            <div className="flex justify-between mt-2">
              <span>Supplier</span>
              <span>
                {item.supplier_name}
              </span>
            </div>

            <div className="flex justify-between mt-2">
              <span>Date</span>
              <span>
                {new Date(item.created_at).toLocaleString()}
              </span>
            </div>

            <div className="flex justify-between mt-2">
              <span>Total</span>
              <span>
                ₹{item.grand_total}
              </span>
            </div>

            <div className="flex justify-between mt-2">

              <span>

                Paid

              </span>

              <span className="text-green-400">

                ₹{Number(item.paid_amount).toFixed(2)}

              </span>

            </div>

            <div className="flex justify-between mt-2">

              <span>

                Due

              </span>

              <span className="text-red-400">

                ₹{Number(item.due_amount).toFixed(2)}

              </span>

            </div>

            <div className="flex justify-between mt-2">

              <span>

                Status

              </span>

              <span
                className={`
px-3
rounded-full
text-xs

${item.payment_status === "Paid"

                    ? "bg-green-600"

                    : item.payment_status === "Partial"

                      ? "bg-yellow-500 text-black"

                      : "bg-red-600"

                  }
`}
              >

                {item.payment_status}

              </span>

            </div>

            <div className="flex gap-2 mt-4">

              {hasPermission("purchase.view") && (
                <button
                  onClick={() =>
                    navigate(
                      `/admin/purchases/${item.id}`
                    )
                  }
                  className="
              flex-1
              py-2
              bg-blue-500
              rounded-lg
            "
                >
                  View
                </button>
              )}

              {

                Number(item.due_amount) > 0 &&

                hasPermission("purchase.add") && (

                  <button
                    onClick={() =>

                      navigate(

                        "/admin/purchases/receive-payment",

                        {

                          state: {

                            purchase: item

                          }

                        }

                      )

                    }
                    className="
flex-1
py-2
bg-green-600
rounded-lg
"
                  >

                    Pay

                  </button>

                )

              }

              {hasPermission("purchase.delete") && (
                <button
                  onClick={() =>
                    deletePurchase(
                      item.id
                    )
                  }
                  className="
              flex-1
              py-2
              bg-red-500
              rounded-lg
            "
                >
                  Delete
                </button>
              )}

            </div>

          </div>

        )
      )}

    </div>

    {/* DESKTOP */}

    <div
      className="
    hidden
    md:block
    bg-[#111]
    rounded-2xl
    overflow-hidden
  "
    >

      <div className="overflow-x-auto">

        <table className="w-full">

          <thead>

            <tr
              className="
            border-b
            border-yellow-500/20
          "
            >

              <th className="p-4 text-left">
                ID
              </th>

              <th className="p-4 text-left">
                Invoice
              </th>

              <th className="p-4 text-left">
                Supplier
              </th>

              <th className="p-4 text-center">
                Date
              </th>

              <th className="p-4 text-center">
                Subtotal
              </th>

              <th className="p-4 text-center">
                GST
              </th>

              <th className="p-4 text-center">
                Discount
              </th>

              <th className="p-4 text-center">
                Grand Total
              </th>

              <th className="p-4 text-center">
                Paid
              </th>

              <th className="p-4 text-center">
                Due
              </th>

              <th className="p-4 text-center">
                Status
              </th>

              <th className="p-4 text-center">
                Action
              </th>

            </tr>

          </thead>

          <tbody>

            {purchases.map(
              (item) => (

                <tr
                  key={item.id}
                  className="
                border-b
                border-yellow-500/10
              "
                >

                  <td className="p-4">
                    {item.id}
                  </td>

                  <td className="p-4">
                    {item.invoice_no}
                  </td>

                  <td className="p-4">
                    {item.supplier_name}
                  </td>

                  <td className="p-4 text-center">
                    {new Date(item.created_at).toLocaleString()}
                  </td>

                  <td className="p-4 text-center">
                    ₹{item.subtotal}
                  </td>

                  <td className="p-4 text-center">
                    ₹{item.gst_total}
                  </td>

                  <td className="p-4 text-center text-red-400">
                    ₹{Number(item.discount || 0).toFixed(2)}
                  </td>

                  <td className="p-4 text-center font-semibold text-yellow-400">
                    ₹{Number(item.grand_total).toFixed(2)}
                  </td>

                  <td className="p-4 text-center text-green-400">
                    ₹{Number(item.paid_amount).toFixed(2)}
                  </td>

                  <td className="p-4 text-center text-red-400">
                    ₹{Number(item.due_amount).toFixed(2)}
                  </td>

                  <td className="p-4 text-center">

                    <span
                      className={`
        px-3
        py-1
        rounded-full
        text-xs
        font-semibold

        ${item.payment_status === "Paid"

                          ? "bg-green-600"

                          : item.payment_status === "Partial"

                            ? "bg-yellow-500 text-black"

                            : "bg-red-600"

                        }

        `}
                    >

                      {item.payment_status}

                    </span>

                  </td>

                  <td className="p-4">

                    <div
                      className="
flex
justify-center
gap-2
flex-wrap
"
                    >

                      {hasPermission("purchase.view") && (

                        <button
                          onClick={() =>
                            navigate(`/admin/purchases/${item.id}`)
                          }
                          className="
px-3
py-2
bg-blue-500
rounded-lg
"
                        >

                          View

                        </button>

                      )}

                      {

                        Number(item.due_amount) > 0 &&

                        hasPermission("purchase.add") && (

                          <button
                            onClick={() =>

                              navigate(

                                "/admin/purchases/receive-payment",

                                {

                                  state: {

                                    purchase: item

                                  }

                                }

                              )

                            }
                            className="
px-3
py-2
bg-green-600
rounded-lg
"
                          >

                            Pay

                          </button>

                        )

                      }

                      {hasPermission("purchase.delete") && (

                        <button
                          onClick={() =>
                            deletePurchase(item.id)
                          }
                          className="
                          px-3
                          py-2
                          bg-red-500
                          rounded-lg
                          "
                        >

                          Delete

                        </button>

                      )}

                    </div>

                  </td>

                </tr>

              )
            )}

          </tbody>

        </table>

      </div>

    </div>

    {/* PAGINATION */}

    <div className="flex gap-2 mt-6">

      <button
        disabled={page === 1}
        onClick={() =>
          setPage(page - 1)
        }
        className="
      px-4
      py-2
      bg-[#111]
      rounded-lg
    "
      >
        Back
      </button>

      {[...Array(pages)].map(
        (_, i) => (
          <button
            key={i}
            onClick={() =>
              setPage(i + 1)
            }
            className={`
            px-4
            py-2
            rounded-lg
            ${page === i + 1
                ? "bg-yellow-500 text-black"
                : "bg-[#111]"
              }
          `}
          >
            {i + 1}
          </button>
        )
      )}

      <button
        disabled={page === pages}
        onClick={() =>
          setPage(page + 1)
        }
        className="
      px-4
      py-2
      bg-[#111]
      rounded-lg
    "
      >
        Next
      </button>

    </div>

  </div>

  );
}

export default Purchases;
